/*
 * Imvelo collection quick-add  (single self-contained file)
 *
 * Hover a product card, size buttons appear; hover a button and it turns into
 * an "Add to cart" button; click adds that exact variant (with its Batch
 * line-item property) via AJAX, with NO page navigation, and slides the side
 * cart open showing the item just added.
 *
 * This ONE file contains everything, behaviour AND styling (it injects its
 * own CSS), and it contains no HTML markup at all, so there is nothing to
 * misplace and nothing for tag-stripping to damage. The whole feature is just:
 * put this JavaScript into the imvelo-quick-add.js asset.
 *
 * Gated to the origin products (handles ending in -single-origin-coffee);
 * the custom blend builder card is intentionally left alone.
 */
(function () {
  var SIZE_HANDLE = /-single-origin-coffee$/;
  var variantCache = {};
  var propsCache = {};

  // Build the cart icon entirely in the DOM (no HTML markup in this file),
  // so the script can't be broken by tag-stripping however it's deployed.
  function makeCartIcon() {
    var NS = 'http://www.w3.org/2000/svg';
    function el(tag, attrs) {
      var node = document.createElementNS(NS, tag);
      for (var k in attrs) node.setAttribute(k, attrs[k]);
      return node;
    }
    var svg = el('svg', {
      viewBox: '0 0 24 24', width: '14', height: '14', fill: 'none',
      stroke: 'currentColor', 'stroke-width': '2',
      'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true'
    });
    svg.appendChild(el('circle', { cx: '9', cy: '21', r: '1' }));
    svg.appendChild(el('circle', { cx: '20', cy: '21', r: '1' }));
    svg.appendChild(el('path', { d: 'M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6' }));
    return svg;
  }

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency) || {};
    var code = cur.active || 'USD';
    var rate = parseFloat(cur.rate);
    if (!rate || isNaN(rate)) rate = 1;
    var amount = (cents / 100) * rate;
    try {
      return new Intl.NumberFormat((window.Shopify && Shopify.locale) || undefined, {
        style: 'currency',
        currency: code
      }).format(amount);
    } catch (e) {
      return code + ' ' + amount.toFixed(2);
    }
  }

  function sizeLabel(v) {
    var t = String(v.option1 || v.title || '').toLowerCase().replace(/\s+/g, '');
    if (/^(1000g?|1kg)$/.test(t)) return '1kg';
    if (/^(500g?)$/.test(t)) return '500g';
    if (/^(250g?)$/.test(t)) return '250g';
    return v.option1 || v.title;
  }

  function getVariants(handle) {
    return variantCache[handle] || (variantCache[handle] =
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { return p.variants; }));
  }

  // Pull the line-item properties the product page injects (e.g. Batch),
  // so a quick-add line is identical to a normal product-page add.
  function getProps(handle) {
    return propsCache[handle] || (propsCache[handle] =
      fetch('/products/' + handle)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var props = {};
          [].slice.call(doc.querySelectorAll('[name^="properties["]')).forEach(function (i) {
            var m = (i.getAttribute('name') || '').match(/^properties\[(.+)\]$/);
            if (m && i.value) props[m[1]] = i.value;
          });
          return props;
        })
        .catch(function () { return {}; }));
  }

  function openDrawerFrom(data) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var html = data && data.sections && data.sections['cart-drawer'];
    if (html) {
      var newInner = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
      var liveInner = drawer.querySelector('.drawer__inner');
      if (newInner && liveInner) liveInner.innerHTML = newInner.innerHTML;
      drawer.classList.remove('is-empty');
    }
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else { // drawer JS not loaded yet: fall back to opening manually
      drawer.classList.add('active', 'animate');
      drawer.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
    }
  }

  function addVariant(handle, variantId, btn) {
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    Promise.resolve(getProps(handle)).then(function (props) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: props || {} }],
          sections: 'cart-drawer',
          sections_url: window.location.pathname
        })
      });
    }).then(function (r) { return r.json(); }).then(function (data) {
      openDrawerFrom(data);
      btn.classList.remove('is-loading');
    }).catch(function () {
      btn.classList.remove('is-loading');
    });
  }

  function buildPanel(media, handle) {
    var panel = document.createElement('div');
    panel.className = 'imvelo-qa';
    panel.setAttribute('data-handle', handle);
    media.appendChild(panel);

    getVariants(handle).then(function (vs) {
      vs.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'imvelo-qa__btn';
        if (!v.available) {
          b.disabled = true;
          b.textContent = sizeLabel(v) + '  \u00b7  Sold out';
        } else {
          var label = document.createElement('span');
          label.className = 'imvelo-qa__label';
          label.textContent = sizeLabel(v) + '  \u00b7  ' + money(v.price);
          var add = document.createElement('span');
          add.className = 'imvelo-qa__add';
          add.appendChild(makeCartIcon());
          var addText = document.createElement('span');
          addText.textContent = 'Add to cart';
          add.appendChild(addText);
          b.appendChild(label);
          b.appendChild(add);
        }
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          addVariant(handle, v.id, b);
        });
        panel.appendChild(b);
      });
    }).catch(function () { panel.remove(); media.__imveloQA = false; });

    // Warm the Batch lookup on hover so the click itself is instant.
    var warm = function () { getProps(handle); };
    media.addEventListener('mouseenter', warm);
    media.addEventListener('focusin', warm);

    // We disabled Dawn's full-card overlay on this card so the buttons are
    // reachable; re-add click-through on the image so it still opens the
    // product (button clicks stop propagation, so they won't trigger this).
    media.addEventListener('click', function (e) {
      if (e.target.closest('.imvelo-qa')) return;
      window.location.href = '/products/' + handle;
    });
  }

  // Collection pages nest .card-wrapper inside .grid__item, so a selector that
  // matches both would wire every product twice. Guard on the shared
  // .card__inner element so each card gets exactly one panel.
  function setupCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!m || !SIZE_HANDLE.test(m[1])) return;
    var media = card.querySelector('.card__inner');
    if (!media || media.__imveloQA) return;
    media.__imveloQA = true;
    card.classList.add('imvelo-qa-card');
    buildPanel(media, m[1]);
  }

  // All styling is injected from here too, so this single file is the ONLY
  // thing that needs to be deployed. No separate CSS to manage or misplace.
  function injectStyle() {
    if (document.getElementById('imvelo-qa-style')) return;
    var style = document.createElement('style');
    style.id = 'imvelo-qa-style';
    style.textContent = [
      ".imvelo-qa-card .card__inner{position:relative;z-index:3;}",
      ".imvelo-qa-card .card__content{position:relative;z-index:1;pointer-events:none;}",
      ".imvelo-qa-card .card__content > *{pointer-events:auto;}",
      ".card__inner .imvelo-qa,.card-wrapper .imvelo-qa{position:absolute;left:0;right:0;bottom:0;z-index:5;display:flex;gap:.5rem;padding:.8rem;background:linear-gradient(to top,rgba(239,232,214,.96),rgba(239,232,214,0));opacity:0;transform:translateY(10px);pointer-events:none;transition:opacity .3s ease,transform .3s ease;}",
      ".grid__item:hover .imvelo-qa,.card-wrapper:hover .imvelo-qa,.grid__item:focus-within .imvelo-qa,.card-wrapper:focus-within .imvelo-qa{opacity:1;transform:translateY(0);pointer-events:auto;}",
      ".imvelo-qa__btn{flex:1 1 0;cursor:pointer;text-align:center;font-family:'Space Mono',ui-monospace,monospace;font-size:1.05rem;letter-spacing:.1em;text-transform:uppercase;color:#141F38;background:rgba(239,232,214,.94);border:1px solid rgba(20,31,56,.3);border-radius:0;padding:1rem .4rem;line-height:1.15;min-height:44px;transition:background .2s ease,color .2s ease,border-color .2s ease;}",
      ".imvelo-qa__btn:hover:not(:disabled){background:#141F38;color:#EFE8D6;border-color:#141F38;}",
      ".imvelo-qa__btn:disabled{opacity:.5;cursor:default;border-color:rgba(20,31,56,.16);color:rgba(20,31,56,.55);}",
      ".imvelo-qa__btn.is-loading{color:transparent;position:relative;pointer-events:none;}",
      ".imvelo-qa__btn.is-loading::after{content:'';position:absolute;top:50%;left:50%;width:14px;height:14px;margin:-7px 0 0 -7px;border:2px solid rgba(20,31,56,.3);border-top-color:#141F38;border-radius:50%;animation:imvelo-qa-spin .6s linear infinite;}",
      "@keyframes imvelo-qa-spin{to{transform:rotate(360deg);}}",
      ".imvelo-qa__add{display:none;align-items:center;justify-content:center;gap:.4rem;}",
      ".imvelo-qa__add svg{width:14px;height:14px;flex:0 0 auto;}",
      ".imvelo-qa__btn:hover:not(:disabled) .imvelo-qa__label{display:none;}",
      ".imvelo-qa__btn:hover:not(:disabled) .imvelo-qa__add{display:inline-flex;}",
      ".imvelo-qa__btn.is-loading .imvelo-qa__label,.imvelo-qa__btn.is-loading .imvelo-qa__add{visibility:hidden;}",
      "@media (hover:none){.card__inner .imvelo-qa,.card-wrapper .imvelo-qa{opacity:1;transform:none;pointer-events:auto;}}",
      /* Dawn makes the whole card clickable via a.full-unstyled-link::after,
         an invisible overlay that sits on top of everything and would swallow
         clicks/hover on our buttons. On cards we enhance, stop that overlay
         from intercepting; we re-add image click-through to the product in JS. */
      ".imvelo-qa-card a.full-unstyled-link::after{pointer-events:none;}"
    ].join("\n");
    document.head.appendChild(style);
  }

  function init() {
    injectStyle();
    document.querySelectorAll('.grid__item, .card-wrapper').forEach(setupCard);
  }

  var rescanTimer;
  function rescan() { clearTimeout(rescanTimer); rescanTimer = setTimeout(init, 120); }

  function boot() {
    init();
    // Watch the whole document so the cards get wired no matter WHEN the grid
    // appears (rendered server-side, hydrated late, or re-rendered by the
    // collection's filter/sort). init() is idempotent, so re-running is safe.
    new MutationObserver(rescan).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Extra triggers in case the grid is ready only after these fire.
  window.addEventListener('load', init);
  setTimeout(init, 400);
  setTimeout(init, 1500);
})();